module.exports = {
          srcSet: __webpack_public_path__ + "f7d2a5f7f85540039186492b15df9701-444.png"+" 444w",
          images:[ {path: __webpack_public_path__ + "f7d2a5f7f85540039186492b15df9701-444.png",width: 444,height: 168}],
          src: __webpack_public_path__ + "f7d2a5f7f85540039186492b15df9701-444.png",
          toString:function(){return __webpack_public_path__ + "f7d2a5f7f85540039186492b15df9701-444.png"},
          
          width: 444,
          height: 168
        }